var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"app-resto-flash"}},[_c('screen',{attrs:{"title":_vm.$t('field.trx_code'),"info":_vm.code}}),_vm._v(" "),_c('keyboard-code',{on:{"cancel":_vm.cancel,"valid":_vm.valid},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }